import type {
    ProductItemOrVariant,
    ProductVariant,
    ReplacementProductDetails,
} from '../types';

function isVariant(item: ProductItemOrVariant): item is ProductVariant {
    return !!(item as ProductVariant).parent;
}

const getReplacementProducts = (
    products: ProductItemOrVariant[]
): ReplacementProductDetails[] => {
    return products.map(product => {
        if (isVariant(product)) {
            return {
                id: product.id,
                sku: product.sku,
                name: product.name,
                media: product.parent?.media || [],
                additionalCharges: product.additionalCharges,
                variants: [],
                groupId: product.groupId,
                rebateCode: product.rebateCode,
                parent: {
                    ...product.parent,
                },
            };
        }

        return {
            id: product.id,
            sku: product.sku,
            name: product.name,
            media: product.media,
            additionalCharges: product.additionalCharges,
            variants: product.variants,
            groupId: product.groupId,
            rebateCode: product.rebateCode,
        };
    });
};

export default getReplacementProducts;
